<section *ngIf="isUnifiedCartReturn; else legacyConfirmation" class="ecb-shell" style="min-height:60vh;padding:60px 20px;text-align:center">
  <div style="max-width:660px;margin:0 auto;background:#fff;padding:42px 28px;border:1px solid #e0eaf0;border-radius:18px;box-shadow:0 12px 35px rgba(10,56,79,.08)">
    <i class="bi bi-shield-check" style="font-size:3rem;color:#0c829f"></i>
    <h1 style="font-weight:800;margin:16px 0">Your training booking</h1>
    <p *ngIf="isCompletingOrder">Verifying your payment status securely...</p>
    <p role="alert" *ngIf="completionError">{{ completionError }}</p>
    <ng-container *ngIf="unifiedCartResult as result">
      <h2 *ngIf="result.status === 'Paid'" style="color:#0a7656">Payment confirmed</h2>
      <h2 *ngIf="result.status !== 'Paid'" style="color:#885b17">Payment status: {{ result.status }}</h2>
      <p *ngIf="result.status !== 'Paid'">Your booking is not confirmed as paid yet. If you completed payment, please check again shortly or contact ECB Training.</p>
      <p><strong>Reference: {{ result.orderNo }}</strong></p>
      <p>{{ result.amount | currency:result.currency:'symbol':'1.2-2' }}</p>
    </ng-container>
    <a routerLink="/course-short" class="btn btn-primary mt-3">Browse courses</a>
  </div>
</section>
<ng-template #legacyConfirmation>
<section class="ecb-hero confirmation-hero">
    <div class="ecb-shell ecb-hero-content">
        <div>
            <h1 class="ecb-hero-title">BOOKING CONFIRMATION</h1>
            <p class="ecb-hero-subtitle">Your course booking has been completed successfully.</p>
        </div>
        <div class="confirm-shield"><i class="fa fa-check"></i></div>
    </div>
</section>
<section class="ecb-shell confirmation-page" *ngIf="paymentType==''">
    <div class="row g-4">
        <div class="col-lg-5">
            <div class="ecb-card success-card p-4">
                <div class="big-check"><i class="fa fa-check"></i></div>
                <h2>Thank you,<br>Your booking is confirmed!</h2>
                <p style="font-size: 13px;">A confirmation email has been sent to <strong>{{ student.email || session.getCurrentUser()?.email ||
                        'your email' }} . Please follow the registration steps in the email to complete your registration and join the course. </strong>We look forward to having you with us!</p>
                <div class="booking-ref"><span>Booking Reference</span><strong>{{ bookingNewReference }}</strong></div>
                <div class="d-flex gap-2 justify-content-center flex-wrap mt-3"><button class="ecb-btn-outline"
                        (click)="downloadInvoice()"><i class="fa fa-download"></i> Download Invoice</button><a
                        routerLink="/" class="ecb-btn-outline"><i class="fa fa-search"></i> Browse More</a></div>
            </div>
        </div>
        <div class="col-lg-7">
            <div class="ecb-card p-4 booking-confirm-summary">
                <h3 class="ecb-card-title">Booking Summary</h3>
                <div class="confirm-course" *ngFor="let item of items"><img
                        [src]="item.course.imageUrl || 'assets/images/forklift.svg'">
                    <div><strong>{{ item.course.courseName }}</strong><span><i class="fa fa-calendar"></i> {{
                            getSelectedTime(item.course.courseId)?.dateRange || '-' }}</span><span><i
                                class="fa fa-clock-o"></i> {{ getSelectedTime(item.course.courseId)?.time || '-'
                            }}</span><span><i class="fa fa-map-marker"></i> {{
                            getSelectedTime(item.course.courseId)?.locationName || item.course.locationName || '-'
                            }}</span></div>
                </div>
                <div class="detail-row"><span>Course Price</span><strong>{{ subtotal | currency:'AUD':'symbol':'1.2-2'
                        }}</strong></div>
                <div class="detail-row"><span>GST (10%)</span><strong>{{ gst | currency:'AUD':'symbol':'1.2-2'
                        }}</strong></div>
                <div class="paid-row"><span>Total</span><strong>{{ total | currency:'AUD':'symbol':'1.2-2' }}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="ecb-card p-4 mt-4">
        <h3 class="ecb-card-title">What happens next?</h3>
        <div class="next-steps">
            <div><i class="fa fa-envelope-o"></i><strong>Confirmation Email</strong><span>Check your inbox for booking
                    confirmation and details.</span></div>
            <div><i class="fa fa-file-text-o"></i><strong>Invoice</strong><span>Download your invoice from this page or
                    purchase history.</span></div>
            <div><i class="fa fa-car"></i><strong>Attend Training</strong><span>Arrive 15 minutes early on your training
                    day with ID.</span></div>
            <div><i class="fa fa-certificate"></i><strong>Get Certified</strong><span>Complete your training and receive
                    your certificate.</span></div>
        </div>
    </div>
</section>


<section class="ecb-shell confirmation-page" *ngIf="
    paymentType === 'REGULAR' ||
    paymentType === 'VOC'
  ">

    <div class="row g-4">

        <!-- Confirmation Card -->
        <div class="col-lg-5">

            <div class="ecb-card success-card p-4">

                <div class="big-check">
                    <i class="fa fa-check"></i>
                </div>

                <h2>
                    Thank you,<br>
                    {{ confirmationTitle }}
                </h2>

                <p style="font-size: 13px;">
                    A confirmation email has been sent to

                    <strong>
                        {{
                        shortCourseDetails?.studentEmail ||
                        'your email'
                        }}
                 . Please follow the registration steps in the email to complete your registration and join the course.   </strong> We look forward to having you with us!
                </p>

                <div class="booking-ref">
                    <span>
                        Booking Reference
                    </span>

                    <strong>
                        {{ bookingReference }}
                    </strong>
                </div>

                <div class="d-flex gap-2 justify-content-center
                 flex-wrap mt-3">

                    <a routerLink="/" class="ecb-btn-outline">

                        <i class="fa fa-search"></i>

                        Browse More
                    </a>

                </div>

            </div>

        </div>

        <!-- Summary -->
        <div class="col-lg-7">

            <div class="ecb-card p-4
               booking-confirm-summary">

                <h3 class="ecb-card-title">
                    {{
                    isVOCPayment
                    ? 'VOC Payment Summary'
                    : 'Short Course Booking Summary'
                    }}
                </h3>

                <div class="confirm-course">

                    <img src="assets/images/forklift.svg" alt="ECB Training course">

                    <div>

                        <strong>
                            {{
                            shortCourseDetails?.courseName ||
                            (
                            isVOCPayment
                            ? 'Verification of Competency'
                            : 'Short Course'
                            )
                            }}
                        </strong>

                        <span *ngIf="
                shortCourseDetails?.courseCode
              ">

                            <i class="fa fa-book"></i>

                            {{
                            shortCourseDetails?.courseCode
                            }}
                        </span>

                        <span *ngIf="isRegularPayment">

                            <i class="fa fa-calendar"></i>

                            {{ courseDateRange }}
                        </span>

                        <span *ngIf="isRegularPayment">

                            <i class="fa fa-clock-o"></i>

                            {{ shortCourseDetails.duration }}
                        </span>

                        <span *ngIf="
                isVOCPayment &&
                shortCourseDetails?.jobNo
              ">

                            <i class="fa fa-briefcase"></i>

                            Job Number:
                            {{ shortCourseDetails?.jobNo }}
                        </span>

                    </div>

                </div>

                <div class="detail-row">

                    <span>
                        Payment Status
                    </span>

                    <strong class="ecb-confirm-paid-status">
                        {{ paymentStatus }}
                    </strong>

                </div>

                <div class="paid-row">

                    <span>
                        Total Paid
                    </span>

                    <strong>
                        {{
                        shortCourseDetails?.totalAmount || 0
                        | currency:
                        (
                        shortCourseDetails
                        ?.currencyCode ||
                        'AUD'
                        ):
                        'symbol':
                        '1.2-2'
                        }}
                    </strong>

                </div>

            </div>

        </div>

    </div>

    <!-- Next Steps -->
    <div class="ecb-card p-4 mt-4">

        <h3 class="ecb-card-title">
            What happens next?
        </h3>

        <div class="next-steps">

            <div>

                <i class="fa fa-envelope-o"></i>

                <strong>
                    Confirmation Email
                </strong>

                <span>
                    Check your inbox for your payment
                    and booking confirmation.
                </span>

            </div>

            <div *ngIf="isRegularPayment">

                <i class="fa fa-calendar-check-o"></i>

                <strong>
                    Course Details
                </strong>

                <span>
                    Review your selected course date
                    and time before attending.
                </span>

            </div>

            <div *ngIf="isRegularPayment">

                <i class="fa fa-car"></i>

                <strong>
                    Attend Training
                </strong>

                <span>
                    Arrive early on your training day
                    with the required identification.
                </span>

            </div>

            <div *ngIf="isVOCPayment">

                <i class="fa fa-file-text-o"></i>

                <strong>
                    VOC Processing
                </strong>

                <span>
                    Your VOC payment has been received
                    and the request will be processed.
                </span>

            </div>

            <div *ngIf="isVOCPayment">

                <i class="fa fa-phone"></i>

                <strong>
                    Further Information
                </strong>

                <span>
                    ECB Training will contact you when
                    additional details are required.
                </span>

            </div>

        </div>

    </div>

    <div *ngIf="isCompletingOrder" class="alert alert-info mt-4">

        <i class="fa fa-spinner fa-spin"></i>

        Confirming your booking...
    </div>

    <div *ngIf="completionError" class="alert alert-warning mt-4">

        {{ completionError }}
    </div>

</section>
</ng-template>
